// extracted by mini-css-extract-plugin
module.exports = {"otpButton":"Form_otpButton__FZSJT"};